import { render, staticRenderFns } from "./rollver_page.vue?vue&type=template&id=bc467458&scoped=true&"
import script from "./rollver_page.vue?vue&type=script&lang=js&"
export * from "./rollver_page.vue?vue&type=script&lang=js&"
import style0 from "./rollver_page.vue?vue&type=style&index=0&id=bc467458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc467458",
  null
  
)

export default component.exports